import axios from 'axios';

const POIS_TO_SHOW_DEFAULT = {
  'sightseeing': true,
  'shows-and-entertainment': true,
  'shopping': true,
  'fnb': true,
  'restaurant': true,
  'whatson': true,
  'hotel': true,
  'lrt': true,
  // turn off by default:
  'freewifi': false,
  'touristinfo': false,
  'drink':  false,
  'nursingroom': false,
  'publictoilet': false,
  'busstop': false,
};

export default () => {
  return {
    namespaced: true,
    state: {
      poisMapFilters: {
        poisToShow: {
          ...POIS_TO_SHOW_DEFAULT,
        },
        range: 200,
      },

      poisCacheByType: Object.fromEntries(Object.keys(POIS_TO_SHOW_DEFAULT).map(type => [type, null])),
      pois: {},

      poisRequestCancel: null,
      poisRequestId: 0,
      poisFetching: false,
      poisFetched: false,
    },
    getters: {
      getPois: (state) => (key) => {
        if (key === undefined) {
          key = 'ALL';
        }
        return state.pois[key];
      }
    },
    mutations: {
      SET_POIS_TO_SHOW(state, poisToShow) {
        state.poisMapFilters.poisToShow = {
          ...state.poisMapFilters.poisToShow,
          ...poisToShow,
        };
      },
      SET_POIS_RANGE(state, range) {
        state.poisMapFilters.range = range;
      },
      
      SET_POIS(state, { key, data }) {
        if (key === undefined) {
          key = 'ALL';
        }
        state.pois[key] = data;
      },
      SET_POIS_FETCHING(state, val) {
        state.poisFetching = val;
      },
      SET_POIS_FETCHED(state, val) {
        state.poisFetched = val;
      },
      SET_POIS_REQUEST_CANCEL(state, cancel) {
        state.poisRequestCancel = cancel;
      },
      SET_POIS_REQUEST_ID(state, id) {
        state.poisRequestId = id;
      },
    },
    actions: {
      SET_POIS_TO_SHOW({ commit }, poisToShow) {
        commit('SET_POIS_TO_SHOW', poisToShow);
      },
      SET_POIS_RANGE({ commit }, range) {
        commit('SET_POIS_RANGE', range);
      },
      ABORT_FETCH_POI({ state, commit }) {
        if (state.poisRequestCancel) {
          state.poisRequestCancel('abort poi request');
          commit('SET_POIS_REQUEST_CANCEL', null);
        }
      },

      async FETCH_POI({ state, commit, dispatch }, { coordinate, locale }) {
        if (state.poisFetching) {
          dispatch('ABORT_FETCH_POI');
        }

        const poisGroupByType = {};
        const poisList = () => {
          const pois = [];
          Object.keys(poisGroupByType).forEach(type => {
            pois.push(...poisGroupByType[type]);
          });
          return pois;
        };

        const types = [];
        Object.keys(state.poisMapFilters.poisToShow).sort().forEach(type => {
          if (state.poisMapFilters.poisToShow[type]) {
            if (state.poisCacheByType[type]) {
              poisGroupByType[type] = state.poisCacheByType[type];
            } else {
              types.push(type);
            }
          }
        });

        const cancelSource = axios.CancelToken.source();
        commit('SET_POIS_REQUEST_CANCEL', cancelSource.cancel);
        const requestId = state.poisRequestId + 1;
        commit('SET_POIS_REQUEST_ID', requestId);
        commit('SET_POIS_FETCHING', true);
        commit('SET_POIS_FETCHED', false);

        const type = types.join(',').replace('shows-and-entertainment', 'entertainment');
        if (!type) {
          dispatch('geolocation/turnOnPOIFilter', null, { root: true });
          const pois = poisList();
          commit('SET_POIS', { key: locale, data: pois });
          commit('SET_POIS_FETCHED', true);
          return pois;
        }

        return axios('/api/pois', {
            params: {
              // coordinate,
              // range: state.poisMapFilters.range,
              type: type,
              lang: locale,
            },
            cancelToken: cancelSource.token,
          })
          .then((result) => {
            const data = result.data || [];
            if (data.length > 0) {
              data.forEach(poi => {
                if (poi.type) {
                  if (!poisGroupByType[poi.type]) {
                    poisGroupByType[poi.type] = [];
                  }
                  poisGroupByType[poi.type].push(poi);
                }
              });
              Object.keys(state.poisCacheByType).forEach(type => {
                if (poisGroupByType[type]) {
                  state.poisCacheByType[type] = poisGroupByType[type];
                } else {
                  state.poisCacheByType[type] = null;
                }
              });
            } else {
              dispatch('geolocation/turnOnPOIFilter', null, { root: true });
            }
            const pois = poisList();
            commit('SET_POIS', { key: locale, data: pois });
            commit('SET_POIS_FETCHED', true);
            return pois;
          })
          .catch((err) => {
            if (axios.isCancel(err)) {
              console.warn('[POI] pois request aborted:', err.message || err);
              return [];
            }
            throw err;
          })
          .finally(() => {
            if (state.poisRequestId === requestId) {
              commit('SET_POIS_FETCHING', false);
              commit('SET_POIS_REQUEST_CANCEL', null);
            }
          });
      },
    },
  };
};
